import * as React from "react";
import { GridItem } from "@chakra-ui/react";
import { Form, Grid, NumberInput, Select } from "components";
import { useCurrentCase, useOrganizationSettings } from "duck";
import { SpeciesEnum } from "requests";
import { constants, Types, hooks, utils } from "./duck";

const PreAnestheticExam: React.FC = () => {
  const exam = useCurrentCase(
    medicalCase => medicalCase.data.client.patient.preAnestheticExam
  );
  const patientSpecies = useCurrentCase(
    medicalCase => medicalCase.data.client.patient.species
  );
  const { temperatureUnitSymbol } = useOrganizationSettings();

  const validation = React.useMemo(() => utils.getValidation(exam || null), [
    exam
  ]);

  const onChange = hooks.useUpdatePreAnestheticExam();

  if (!exam) {
    return null;
  }

  return (
    <Form<Types.FormValues> {...validation}>
      <Form.Watcher
        defaultValues={validation.defaultValues}
        onChange={onChange}
      />
      <Grid
        templateColumns={{
          base: "1fr",
          sm: "repeat(2, 1fr)"
        }}
      >
        <GridItem>
          <NumberInput
            min={0}
            name="temperature"
            label={`Temperature (${temperatureUnitSymbol})`}
            placeholder="Enter details here"
          />
        </GridItem>

        <GridItem>
          <NumberInput
            name="heartRate"
            label="Heart Rate"
            placeholder="Enter details here"
            precision={0}
            min={0}
          />
        </GridItem>

        <GridItem>
          <NumberInput
            name="respiratoryRate"
            precision={0}
            min={0}
            label="Respiratory Rate"
            placeholder="Enter details here"
          />
        </GridItem>

        <GridItem>
          <NumberInput
            precision={0}
            min={0}
            name="painScore"
            label="Pain Score"
            placeholder="Enter details here"
          />
        </GridItem>

        <GridItem colSpan={2}>
          <Select
            noInputWrap
            isSearchable={false}
            name="bodyConditionScore"
            label="Body Condition Score"
            placeholder="Enter details here"
            options={
              patientSpecies === SpeciesEnum.Cat
                ? constants.CAT_BODY_SCORE_CONDITIONS
                : constants.DOG_BODY_SCORE_CONDITIONS
            }
          />
        </GridItem>

        <GridItem colSpan={2}>
          <Select
            noInputWrap
            isSearchable={false}
            name="dentalScore"
            label="Dental Score"
            placeholder="Enter details here"
            options={constants.DENTAL_SCORE_OPTIONS}
          />
        </GridItem>

        <GridItem colSpan={2}>
          <Select
            noInputWrap
            isSearchable={false}
            label="ASA Physical Status"
            name="physicalStatus"
            placeholder="Enter details here"
            options={constants.PHYSICAL_STATUS_OPTIONS}
          />
        </GridItem>
      </Grid>
    </Form>
  );
};

export default PreAnestheticExam;
